import { defineStore } from "pinia"
import { computed, ref } from "vue"

export const useLoadingStore = defineStore('loading', () => {
  const __count = ref(0)
  const loading = computed(() => __count.value > 0)

  const __startLoading = () => {
    __count.value++
  }

  const __endLoading = () => {
    __count.value--
    if (__count.value < 0) {
      console.warn('[loading] count < 0. reset to 0.')
      __count.value = 0
    }
  }

  const loadingProc = async <T = any>(callback: () => Promise<T>) => {
    try {
      __startLoading()
      return await callback()
    } finally {
      __endLoading()
    }
  }

  return {
    loading,
    loadingProc,
    /** ※使用しない */
    __count,
    /** ※単体で呼び出さない. 必ず __endLoading と対になる形で使用する. */
    __startLoading,
    /** ※単体で呼び出さない. 必ず __startLoading と対になる形で使用する. */
    __endLoading,
  }
})
